import { Plug, QrCode } from "react-bootstrap-icons";
import { IntegrationStatus } from "./Data/ApiTransport";
import { ServerRequestsParkerIntegrationPartyDto } from "./shared/api/axios-client";
import { Button } from "./Controls/Button";

interface Props {
  integrations: ServerRequestsParkerIntegrationPartyDto[];
  subscriptionId: number;
  facilityId: number;
  setPendingToggle: (data: {
    integrationPartyId: number;
    subscriptionId: number;
    parkerId: number;
    facilityId: number;
    newStatus: IntegrationStatus;
  }) => void;
  setShowToggleConfirm: (show: boolean) => void;
  setQrCodeData: (data: string) => void;
  setShowQrModal: (show: boolean) => void;
}

export function ParkerIntegrations({
  integrations,
  subscriptionId,
  facilityId,
  setPendingToggle,
  setShowToggleConfirm,
  setQrCodeData,
  setShowQrModal,
}: Props) {
  return (
    <div className="border rounded p-3 mb-4">
      <div className="d-flex align-items-center mb-2">
        <Plug className="me-2" />
        <strong>Integrations</strong>
      </div>

      <div className="d-flex flex-column gap-3">
        {integrations.length > 0 ? (
          integrations.map((integration) => (
            <div
              key={`${integration.integrationPartyId}-${integration.parkerId}`}
              className="border rounded p-3 bg-white"
            >
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="fw-bold mb-1">
                    {integration.integrationName}
                  </div>
                  <div className="text-muted small">
                    {integration.metaFlashUID && (
                      <div>UID: {integration.metaFlashUID}</div>
                    )}
                    {integration.metaFlashRFIDNumber && (
                      <div>RFID: {integration.metaFlashRFIDNumber}</div>
                    )}
                  </div>
                </div>

                <div className="d-flex flex-column align-items-end gap-2">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id={`switch-${integration.integrationPartyId}-${integration.parkerId}`}
                      checked={integration.isActive}
                      onChange={() => {
                        const newStatus = integration.isActive
                          ? IntegrationStatus.Deactivated
                          : IntegrationStatus.Activated;

                        setPendingToggle({
                          integrationPartyId: integration.integrationPartyId!,
                          subscriptionId,
                          parkerId: integration.parkerId!,
                          facilityId,
                          newStatus,
                        });
                        setShowToggleConfirm(true);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`switch-${integration.integrationPartyId}-${integration.parkerId}`}
                    >
                      Integration Is{" "}
                      {integration.isActive ? "Activated" : "Deactivated"}
                    </label>
                  </div>

                  {(integration.isActive || integration.parkerId === 0) &&
                    integration.metaFlashRFIDNumber && (
                      <Button
                        className="btn-main py-1 px-3"
                        onClick={() => {
                          setQrCodeData(integration.metaFlashRFIDNumber!);
                          setShowQrModal(true);
                        }}
                      >
                        <QrCode
                          className="me-1"
                          style={{ marginTop: "-2px" }}
                        />
                        View QR Code
                      </Button>
                    )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-muted small mb-2">No active integrations.</div>
        )}
      </div>
    </div>
  );
}